"use client";
import React, { useState } from "react";
import * as Collapsible from "@radix-ui/react-collapsible";
import Card from "@/components/primitives/card";
import Icon from "@/components/primitives/icon";
import Offer from "@/components/sportsbook/offer";
import styles from "@/app/(public)/sportsbooks/[slug]/styles.module.css";

interface CollapsibleOffersProps {
  offers: any[];
  sportsbookTitle: string;
  thumbnailUrl?: string;
  promoImage?: {
    url: string;
    caption: string;
  };
  firstOfferButtonUrl?: string;
}

export default function CollapsibleOffers({
  offers,
  sportsbookTitle,
  thumbnailUrl,
  promoImage,
  firstOfferButtonUrl,
}: CollapsibleOffersProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Card
      id="offers"
      // className={styles.cardPadding}
      className="!p-0"
    >
      <Collapsible.Root open={isOpen} onOpenChange={setIsOpen}>
        <Collapsible.Trigger className={styles.collapsibleTrigger}>
          <div className={styles.offersHeader}>
            <p className="text-headline-lg uppercase whitespace-normal">
              {sportsbookTitle} Offers
            </p>
            <div className={styles.offersCount}>{offers.length}</div>
          </div>
          <div
            className={`lg:hidden transition-transform fill-primary-200 ${
              isOpen ? "rotate-180" : ""
            }`}
          >
            <Icon name="caret-down" size="sm" />
          </div>
          <div
            className={`hidden lg:block transition-transform fill-primary-200 ${
              isOpen ? "rotate-180" : ""
            }`}
          >
            <Icon name="caret-down" size="md" />
          </div>
        </Collapsible.Trigger>

        <Collapsible.Content className={styles.collapsibleContent}>
          <div className="px-6 lg:px-10 pb-6 lg:pb-10">
            <div className="flex flex-col card-body">
              {offers.length > 0 ? (
                offers.map((offer: any, i: number) => {
                  return (
                    <Offer
                      key={i}
                      offer={offer}
                      sportsbook={{
                        title: sportsbookTitle,
                        thumbnailUrl: thumbnailUrl || "",
                      }}
                    />
                  );
                })
              ) : (
                <div>There are no offers</div>
              )}
            </div>

            {promoImage && (
              <a
                href={firstOfferButtonUrl}
                target="_blank"
                rel="nofollow noopener noreferrer"
              >
                <img
                  src={promoImage.url}
                  alt={promoImage.caption}
                  className={styles.promoImage}
                />
              </a>
            )}
          </div>
        </Collapsible.Content>
      </Collapsible.Root>
    </Card>
  );
}
